// removed by extract-text-webpack-plugin
module.exports = {"notes":"notes__2AoSx"};


//////////////////
// WEBPACK FOOTER
// ./components/notes/style.css
// module id = EwwD
// module chunks = 0